module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请选择要认领的热点")]), _vm._v(" "), _c('div', {
    staticClass: "list-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("加载中，请稍候...")]) : _vm._l((_vm.wifiList), function(item, index) {
    return _c('wifi-item', {
      key: index,
      attrs: {
        "item": item
      },
      on: {
        "click": _vm.handleWifiItemClick
      }
    })
  }), _vm._v(" "), (_vm.isShowEmpty) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("请在设置>更多设置>权限管理中，授权WiFi万能钥匙开启定位权限，才能查找附近WiFi")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "refresh-button",
    attrs: {
      "type": "primary",
      "block": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v("刷新列表")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c0d5896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wifiSelect/index.vue
// module id = 831
// module chunks = 1